import { render, staticRenderFns } from "./Slapped.vue?vue&type=template&id=875d5842&scoped=true&"
import script from "./Slapped.vue?vue&type=script&lang=js&"
export * from "./Slapped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875d5842",
  null
  
)

export default component.exports